const constants = {
    // eslint-disable-next-line quotes
    title: "Joe's Meats",
    // eslint-disable-next-line quotes
    entityName: "Joe's Meats",
};
export { constants };
